export const GetBrowserLang = (): string => {
  if (navigator.language.includes('fr')) {
    return 'fr';
  } else if (navigator.language.includes('en')) {
    return 'en'
  }
  return 'nl';
}

export const GetCurrentLocale = () => {
  let langArray: Array<string> = ['fr', 'nl', 'en'];
  let Url = require('url-parse');
  let currentURL = new Url(window.location.href);
  let currentPathName = currentURL.pathname as string;
  let pathNameParts = currentPathName.split('\/');
  if (pathNameParts.length < 1) {
    return GetBrowserLang();
  } else {
    if (langArray.indexOf(pathNameParts[1]) > -1) {
      return(pathNameParts[1])
    }
  }
  return GetBrowserLang();
}

export const GetUrlParams = () => {
  let Url = require('url-parse');
  let currentURL = new Url(window.location.href);
  let currentQuery = currentURL.query as string;
  currentQuery = currentQuery.substr(1); //Pour retirer le premier "?"

  let queryParts = currentQuery.split('&');

  let currentParams : { [s: string]: string; } = {};

  if (queryParts.length > 0) {
    for(let index = 0; index < queryParts.length; index++) {
      const param = queryParts[index].split('=');

      if(param.length > 1) {
        currentParams[param[0]] = decodeURI(param[1]);
      }
    }
  }

  return currentParams;
}

export function scrollToId(id: string){
  let idAnchor = document.getElementById(id);
  if(idAnchor !== null){
    let positionId = idAnchor.getBoundingClientRect();
    if(positionId !== undefined){
      window.scrollTo({
        behavior: "smooth",
        top: positionId.y
      });
    }
  }
}

export const isResponsive = window.innerWidth <= 991 && window.innerWidth > 321;
export const isTablet = window.innerWidth <= 768;
export const isSmartphone = window.innerWidth <= 320;
export let pathname = window.location.pathname;
export const urlParams = window.location.search;
export interface SelectInterface {
  label: string;
  value: any;
}

export const customSelectStyles = {
  option: (provided: any, state: { isSelected: any; isFocused: any }) => ({
    ...provided,
    color: '#51585e',
    backgroundColor: state.isSelected ? "#f9f9f9" : "#fff",
    "&:hover": {
      // Overwrittes the different states of border
      backgroundColor: "#f9f9f9"
    }
  }),
  menu: (provided: any, state: { isSelected: any; isFocused: any }) => ({
    ...provided,
    color: '#51585e',
    backgroundColor: "#f9f9f9",
  }),
}

export const FormatDateForUrl = (baseDate: Date): string => {
  let date = new Date(baseDate);
  return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
}

// fonction qui permet de grouper selon une key un array
export const groupBy = (array: any[]|null, key: any) => {
  return array && array.reduce((result: any[]|null, currentValue: any ) => {
    if (result) {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
    }
    return result;
  }, {});
};

export const injectHtmlMetaTag = (titre: string, description: string, keywords: string) => {
  document.title = titre;

  // Il les ajoute deux fois, donc pour éviter les doublons, on supprime d'abord
  const existingDescriptionTag = document.querySelector('meta[name="description"]');
  if (existingDescriptionTag) {
    existingDescriptionTag.remove();
  }
  const existingKeywordsTag = document.querySelector('meta[name="keywords"]');
  if (existingKeywordsTag) {
    existingKeywordsTag.remove();
  }
  if (description !== null) {
    const descriptionTag = document.createElement('meta');
    descriptionTag.name = 'description';
    descriptionTag.content = description;
    document.head.appendChild(descriptionTag);
  }
  if (keywords !== null) {
    const keywordsTag = document.createElement('meta');
    keywordsTag.name = 'keywords';
    keywordsTag.content = keywords;
    document.head.appendChild(keywordsTag);
  }
}

// export const injectOGSocialNetworks = (title: string, slug: string, metaDescription: string, trainingDetail: TrainingDetail) => {
//   const currentChannel = getCurrentChannel();
//   const currentLocale = GetCurrentLocale()
//   const IMG_URL = getURLParam(URLParamEnum.FILES_IMG_URL);
//   const img = getImageHeader(trainingDetail) ? getImageHeader(trainingDetail) : IMG_URL + 'default-img-formation.png';
//
//   // Il les ajoute deux fois, donc pour éviter les doublons, on supprime d'abord
//   const ogTags = document.querySelectorAll('meta[property^="og:"]');
//   ogTags.forEach(tag => tag.remove());
//
//   document.head.innerHTML += '<meta property="og:title" content="'+title+'" />';
//   document.head.innerHTML += '<meta property="og:url" content="trainingsolutions.localhost'+ "/"+ currentLocale + t('url_formation') +"/"+ slug +'" />';
//   document.head.innerHTML += '<meta property="og:image" content="'+img+'" />';
//   document.head.innerHTML += '<meta property="og:description" content="'+metaDescription+'" />';
//   document.head.innerHTML += '<meta property="og:site_name" content="'+currentChannel+'" />';
//   document.head.innerHTML += '<meta property="og:type" content="product" />';
// }
